import React from 'react';
import LootboxSheet from '../../lootbox/components/LootboxSheet';
import { formatAmount, levelValue } from '../utils/missionMath';
import { buildingName, COIN_ICON, resolveAssetUrl } from '../utils/lairAssets';
import { useTranslation } from 'react-i18next';

/**
 * Hero picker of a farm (v1.47.0): every complete hero with its level and the coins it would bring
 * per cycle on this farm; heroes on a mission / another farm are disabled.
 */
export default function FarmHeroSheet({ farm, heroes, farmsById, busy, error, onPick, onClose, onGoToHeroes }) {
  const { t } = useTranslation();
  const list = (heroes || [])
    .filter((h) => h.complete)
    .map((h, i) => ({
      ...h,
      label: t('lair.hero_n', 'Hero {{n}}', { n: i + 1 }),
      coins: levelValue(farm.levelCoins, h.level),
      reason: h.onMission ? t('lair.hero.on_mission', 'On mission')
        : h.farmBuildingId && h.farmBuildingId !== farm.id
          ? t('lair.hero.in_farm', 'In {{farm}}', {
            farm: farmsById[h.farmBuildingId] ? buildingName(farmsById[h.farmBuildingId], t) : t('lair.hero.a_farm', 'a farm'),
          })
          : null,
    }))
    .sort((a, b) => (!!a.reason - !!b.reason) || b.level - a.level);

  return (
    <LootboxSheet
      title={buildingName(farm, t)}
      onClose={onClose}
      footer={(closeThen) => (
        <>
          {error && <div className="chest-info-error">{error}</div>}
          {list.length === 0 && (
            <button type="button" className="app-btn app-btn--purple" onClick={() => closeThen(onGoToHeroes)}>
              {t('lair.assemble_hero', 'Assemble a hero')}
            </button>
          )}
        </>
      )}
    >
      {list.length === 0 ? (
        <div className="lair-empty lair-empty--sheet">{t('lair.farm.complete_hero', 'Complete a hero to put it to work.')}</div>
      ) : (
        <div className="lair-heroes">
          {list.map((h) => (
            <button
              key={h.id}
              type="button"
              className={`lair-hero${h.reason ? ' lair-hero--disabled' : ''}`}
              disabled={!!h.reason || busy}
              onClick={() => onPick(h)}
            >
              <div className="lair-hero__avatar">
                <img src={resolveAssetUrl(h.headImageUrl) || '/inventory/character.png'} alt="" />
              </div>
              <div className="lair-hero__info">
                <div className="lair-hero__name">{h.label} <span className="lair-hero__lvl">{t('lair.level_short', 'Lv {{n}}', { n: h.level })}</span></div>
              </div>
              <div className="lair-hero__right">
                {h.reason
                  ? <span className="lair-hero__reason">{h.reason}</span>
                  : <span className="lair-hero__coins"><img src={COIN_ICON} alt="" />{formatAmount(h.coins)}</span>}
              </div>
            </button>
          ))}
        </div>
      )}
    </LootboxSheet>
  );
}
